import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import useLoginCheck from "../util/useLoginCheck";
import { createRestaurantList } from "../slice/restaurantListsSlice";

const CreateRestaurantList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useLoginCheck();

  const inputClasses =
    "w-full border border-stone-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600";

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSaving(true);
      const resultAction = await dispatch(
        createRestaurantList({ name, type, members: [], items: [] })
      );
      if (createRestaurantList.fulfilled.match(resultAction)) {
        navigate(`/restaurants/${resultAction.payload.sid}`);
      }
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-4 md:p-6">
      <form onSubmit={handleSubmit} className="card p-4 md:p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-stone-500 mb-1">
            Name
          </label>
          <input
            type="text"
            className={inputClasses}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-stone-500 mb-1">
            Type
          </label>
          <input
            type="text"
            className={inputClasses}
            placeholder="e.g. Want to try"
            value={type}
            onChange={(e) => setType(e.target.value)}
          />
        </div>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn-secondary"
          >
            Cancel
          </button>
          <button type="submit" disabled={isSaving} className="btn-primary">
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateRestaurantList;
